import { EscopoMacroLinhaView } from "./view-escopo-macro-linha";
import type { EscopoMacroLinhaProps } from "./types-escopo-macro-linha";

export function EscopoMacroLinha(props: EscopoMacroLinhaProps) {
  return <EscopoMacroLinhaView {...props} />;
}

export type * from "./types-escopo-macro-linha";
